// This file configures the initialization of Sentry on the client.
// The config you add here will be used whenever a users loads a page in their browser.
// https://docs.sentry.io/platforms/javascript/guides/nextjs/

;globalThis["_sentryRewritesTunnelPath"] = "/monitoring";globalThis["SENTRY_RELEASE"] = {"id":"47647b4327c66ab6a599cce35c726e0b3648ba51"};globalThis["_sentryBasePath"] = undefined;globalThis["_sentryRewriteFramesAssetPrefixPath"] = "";import * as Sentry from "@sentry/nextjs";

import { sentryEventHooks } from "@punchup/sentry";

Sentry.init({
  dsn: "https://ee23cd95da8f47b4abeffecf47400589@o4505509133418496.ingest.sentry.io/4505509139316736",

  // Enabled in production. To test client-side Sentry features locally (e.g. the
  // in-app feedback widget), set NEXT_PUBLIC_ALLOW_SENTRY_LOGGING_ON_DEV=1 in
  // your env AND enable the Sentry webpack plugin locally (see next.config.js).
  // Do not commit those local toggles.
  enabled:
    process.env.VERCEL_ENV === "production" ||
    process.env.NEXT_PUBLIC_ALLOW_SENTRY_LOGGING_ON_DEV === "1",

  // Adjust this value in production, or use tracesSampler for greater control
  tracesSampleRate: 0.02,

  // Setting this option to true will print useful information to the console while you're setting up Sentry.
  debug: false,

  replaysOnErrorSampleRate: 0.02,

  // This sets the sample rate to be 2%. You may want this to be 100% while
  // in development and sample at a lower rate in production
  replaysSessionSampleRate: 0.02,

  // You can remove this option if you're not planning to use the Sentry Session Replay feature:
  integrations: [
    Sentry.replayIntegration({
      // Additional Replay configuration goes in here, for example:
      maskAllText: true,
      blockAllMedia: true,
    }),
    Sentry.feedbackIntegration({
      autoInject: false,
      colorScheme: "light",
      showBranding: false,
      enableScreenshot: true,
      themeLight: {
        accentBackground: "#ff5e26", // Punchup orange primary (was #3D2BAE purple)
        accentForeground: "#ffffff",
      },
    }),
  ],

  ignoreErrors: [
    "ResizeObserver loop limit exceeded",
    "ResizeObserver loop completed with undelivered notifications",
    // Sentry error: https://punchup.sentry.io/issues/4706563944/events/81bf0b5004974cacb3e931e163414afd/
    // Problem/solution context: https://github.com/getsentry/sentry-javascript/issues/3440
    /Non-Error promise rejection captured with value: Object Not Found Matching Id:(\d+), MethodName:([^,]+), ParamCount:(\d+)/,
  ],
  ...sentryEventHooks,
});
